<script lang="ts">
  import { Button,Form, Col, Input, Label, FormGroup } from "sveltestrap";
  import { Cancel, DefaultFormLayout, Emailaddress, FormMessag, Formtext, Password, Remembermyreference, Submit } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte"
</script>
<Col sm="12">
    <Card headerTitle={DefaultFormLayout} cardHeaderprops="pb-0">
      <div slot="customheader">
        <span>{@html FormMessag}</span>
      </div>
      <div slot="contentbody">
        <Form class="theme-form">
          <FormGroup>
            <Label class="col-form-label pt-0" for="exampleInputEmail1">{Emailaddress}</Label>
            <Input id="exampleInputEmail1" type="email" aria-describedby="emailHelp" placeholder="Enter email" />
            <small class="form-text text-muted" id="emailHelp">{Formtext}</small>
          </FormGroup>
          <FormGroup>
            <Label class="col-form-label pt-0" for="exampleInputPassword1">{Password}</Label>
            <Input id="exampleInputPassword1" type="password" placeholder="Password" />
          </FormGroup>
          <div class="checkbox p-0">
            <input id="dafault-checkbox" type="checkbox">
            <label class="mb-0" for="dafault-checkbox">{Remembermyreference}</label>
          </div>
        </Form>
      </div>
      <div slot="contentfooter">
        <Button color="primary" >{Submit}</Button>
        <Button color="secondary">{Cancel}</Button>
      </div>
    </Card>
</Col>